import { GuidebookSummaryFacilityContainer } from "containers/GuidebookSummaryContainer";
import { GetStaticProps } from "next";

export const getStaticProps: GetStaticProps = async () => {
  const description = "보건복지부에서 발행한 <2022 장사업무 안내>를 참고한 장지에 대한 모든 정보.";

  return {
    props: {
      pageDescription: description,
      pageOgTitle: "장지 한눈에 보기 - [고이 장례 가이드북]",
      pageOgDescription: description,
      pageKeywords: "장지, 봉안당, 납골당, 수목장, 화초장, 잔디장, 장지 비용, 화장장, 납골당 추천",
    },
  };
};

interface Page {
  pageOgTitle: string;
}

function GuidebookSummaryFacility({ pageOgTitle }: Page) {
  return (
    <>
      <GuidebookSummaryFacilityContainer />
    </>
  );
}

export default GuidebookSummaryFacility;
